import { render, staticRenderFns } from "./AttachmentsOtherFiles.vue?vue&type=template&id=e951dd1a"
import script from "./AttachmentsOtherFiles.vue?vue&type=script&lang=js"
export * from "./AttachmentsOtherFiles.vue?vue&type=script&lang=js"
import style0 from "../attachments-shared.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports